import { Component, OnInit } from "@angular/core";
import { UntypedFormControl } from "@angular/forms";
import { NbDialogRef } from "@nebular/theme";

@Component({
  selector: "morva-edit-dialog",
  templateUrl: "./edit-dialog.component.html",
  styleUrls: ["./edit-dialog.component.scss"],
})
export class EditDialogComponent implements OnInit {
  assetName = new UntypedFormControl("");
  asset: any;
  isNameValidState: boolean = false;

  constructor(protected dialogRef: NbDialogRef<any>) {}

  ngOnInit(): void {
    this.getAsset();
    this.updateNameValidity();
    this.assetName.valueChanges.subscribe(() => this.updateNameValidity());
  }

  closeDialog() {
    this.dialogRef.close();
  }

  updateNameValidity(): void {
    const trimmed = (this.assetName.value || "").trim();
    this.isNameValidState = trimmed !== "" && trimmed !== (this.asset?.name || "").trim();
  }

  editAsset() {
    this.asset.name = (this.assetName.value || "").trim();
    this.dialogRef.close(this.asset);
  }

  getAsset() {
    this.asset = this.dialogRef.componentRef.instance;
    this.assetName.setValue(this.asset?.name);
  }
}
